module.exports = __webpack_public_path__ + "static/media/bright-white-acid-free.70de176c.png";